module.exports = __webpack_public_path__ + "static/media/5_6.3c427d3e.png";